export default __webpack_public_path__ + "static/media/BLR-7.c74eca39.JPG";